import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Asidebar from "../Header/Asidebar";

import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addUser } from "../../redux/userSlice";
import { getData } from "../../FetchNodeServices";
import AlertMessages from "../Mains/Alerts";

const Dasboard = () => {
  const [isActivated, setIsActivated] = useState(true);
  const [fullwidthwrapper, setFullwidthwrapper] = useState();
  const [alerts, setAlerts] = useState([]);
  const dispatch = useDispatch();
  const handleToggle = () => {
    setIsActivated(!isActivated);
    setFullwidthwrapper(isActivated ? "fullwrapper" : "");
  };

  const userRole = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).userRole;
  const getUserIdByRole = async () => {
    if (userRole === "A") {
      let user = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"));
      dispatch(addUser(user));
    } else if (userRole === "U") {
      var user = localStorage.getItem("user") && JSON.parse(localStorage.getItem("user")).parentAccountId;
      let result = await getData("users/get-user/" + user);
      // let result = await getData("users/basic-details/" + user);
      dispatch(addUser(result));
    }
  };

  useEffect(function () {
    getUserIdByRole();
    setAlerts([{ variant: "success", heading: "Data fetched successfully." }]);
  }, []);

  return (
    <div>
      <Asidebar isActivated={isActivated} />
      <div id="wrapper" className={fullwidthwrapper}>
        <Header onclick={handleToggle} />

        <div id="page_wrapper" className="py-2">
          <div className="card p-3 border-light-subtle ">
            <ul className="breadcrumb m-0">
              <li>
                <Link to="/dashboard">
                  <i className="bi bi-people mx-2"></i> Dashboard
                </Link>
              </li>
              <li>
                <span className="breadcrumb_slash">/</span> <i className="bi bi-app-indicator mx-2"></i> Manage Customer
              </li>
            </ul>
            <div className="position-absolute top-0  start-0 w-100 h-100 " style={{ zIndex: 1050 }}>
              <AlertMessages alerts={alerts} setAlerts={setAlerts} />
            </div>
          </div>
        </div>

        <div className="column px-3 py-1">
          <div className="row">
            <div className="col-lg-3">
              <div className="card p-2 border-light-subtle">
                <div className="common_form p-2">
                  <label for="">Active users</label>
                  <span className="h5 fw-bold">50,000</span>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card p-2 border-light-subtle">
                <div className="common_form p-2">
                  <label for="">Survey clicks</label>
                  <span className="h5 fw-bold">2,000</span>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card p-2 border-light-subtle">
                <div className="common_form p-2">
                  <label for="">Click Rate</label>
                  <span className="h5 fw-bold">18%</span>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card p-2 border-light-subtle">
                <div className="common_form p-2">
                  <label for="">Completes</label>
                  <span className="h5 fw-bold">300</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="column p-3 ">
          <div className="row">
            <div className="col-lg-6">
              <div className="card p-2 border-light-subtle">
                <div className="common_form p-2 text-center ">

                  <label className="mt-2 fw-bold" for="">
                    Age
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card p-2 border-light-subtle">
                <div className="common_form p-2 text-center">

                  <label className="mt-2 fw-bold" for="">
                    Employment
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="column p-3 ">
          <div className="row">
            <div className="col-lg-6 ">
              <div className="card p-2 border-light-subtle">
                <div className="common_form p-2 text-center">

                  <label className="mt-2 fw-bold" for="">
                    Income
                  </label>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card p-2 border-light-subtle">
                <div className="common_form p-2 text-center">

                  <label className="mt-2 fw-bold" for="">
                    Employment
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dasboard;
